import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'fortune-card',
  name: '运势检测卡',
  icon: '运',
  group: '国学组件',
  description: '展示今日运势评分、档案入口和多维趋势。',
  defaultProps: {
    title: '运势检测卡',
    subtitle: '添加档案解锁专属运势',
    icon: '问',
    scoreLabel: '今日指引',
    score: '98',
    buttonText: '添加档案',
    link: '/pages/guoxue/profile',
    metrics: [
      { label: '情感', color: '#8A4FB8' },
      { label: '事业', color: '#4D65A8' },
      { label: '财运', color: '#8B6B6D' },
      { label: '健康', color: '#5B7F9B' }
    ]
  }
}
